import ChartTypeFilter from './ChartTypeFilter'

export default ChartTypeFilter



// WEBPACK FOOTER //
// ./src/modules/Filters/ChartTypeFilter/index.js